export default {
  getToken(state) {
    return state.token;
  },

  getUserGeoData(state) {
    return state.userGeo;
  },

  isLoggedIn(state) {
    if (localStorage.getItem("isLoggedIn")) {

      return true;
    }

    return state.isLoggedIn;
  }
};
